<template>
  <v-dialog :model-value="dialogValue" persistent width="500">
    <v-card>
      <v-card-title class="d-flex justify-end">
        <v-icon icon="fa-regular fa-xmark" :size="24" flat @click="$emit('close')" />
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="playlistName" variant="outlined" placeholder="Nosaukums" />
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn :disabled="!canCreate || creating" :loading="creating" @click="createPlaylist()">Izveidot</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { isContentPresent } from "~/helpers"
import usePlaylistsStore from "~/stores/playlistsStore"

export default {
  props: {
    dialogValue: {
      required: true,
      type: Boolean,
    },
  },

  emits: ["close"],

  setup() {
    const playlistsStore = usePlaylistsStore()
    return {
      playlistsStore,
    }
  },

  data() {
    return {
      playlistName: "" as string,
      canCreate: false as boolean,
      creating: false as boolean,
    }
  },

  watch: {
    playlistName(newValue) {
      this.canCreate = !!isContentPresent(newValue)
    },
  },

  methods: {
    createPlaylist() {
      this.creating = true
      this.playlistsStore.createNewPlaylist({
        name: this.playlistName,
        successCallback: this.successPlaylistCreate,
        errorCallback: this.errorPlaylistCreate,
      })
    },

    successPlaylistCreate() {
      this.creating = false
      this.playlistName = ""
      this.$emit("close")
    },

    errorPlaylistCreate() {
      this.creating = false
    },
  },
}
</script>
